import React from 'react';
import styles from './SentenceCard.module.css';
import { HeartIcon, LoaderIcon } from '../../../../components/Icons';

/**
 * 共享句子卡片组件
 * 用于 ChapterLearn 和 BookSentencesListPage
 *
 * @param {object}   sentence          - 句子数据
 * @param {boolean}  showChinese       - 是否显示中文（默认 true）
 * @param {boolean}  favoriteLoading   - 收藏操作加载中
 * @param {function} onFavoriteToggle  - 取消收藏回调
 * @param {object}   playingClip       - { en: sentenceId|null, cn: sentenceId|null }
 * @param {function} onPlayClip        - (sentence, lang) => void
 * @param {function} onStopClip        - (lang) => void
 */
const SentenceCard = ({
  sentence,
  showChinese = true,
  favoriteLoading = false,
  onFavoriteToggle,
  playingClip = {},
  onPlayClip,
  onStopClip,
}) => {
  if (!sentence) return null;

  const sentenceId = sentence.id ?? sentence.favorite_id ?? sentence.favoriteId ?? sentence.sentence_id;
  const sentenceIndex = sentence.sentence_id ?? sentence.sentenceId;

  const hasEnClip = sentence.en_start_timestamp != null && sentence.en_end_timestamp != null;
  const isEnPlaying = playingClip.en === sentence.id;

  return (
    <article className={styles.card}>
      <header className={styles.header}>
        <div className={styles.headerLeft}>
          <span className={styles.label}>
            SENTENCE {sentenceIndex ?? ''}
          </span>
          {hasEnClip && (
            <button
              type="button"
              className={`${styles.audioBtn} ${isEnPlaying ? styles.audioBtnActive : ''}`}
              onClick={() =>
                isEnPlaying ? onStopClip?.('en') : onPlayClip?.(sentence, 'en')
              }
              aria-label="播放英文发音"
              title="播放英文发音"
            >
              <span className="material-symbols-rounded">volume_up</span>
            </button>
          )}
        </div>
        <div className={styles.actions}>
          {sentence.created_at && (
            <time className={styles.meta}>
              {new Date(sentence.created_at).toLocaleString()}
            </time>
          )}
          <button
            type="button"
            className={styles.favoriteBtn}
            onClick={() => onFavoriteToggle?.(sentence)}
            disabled={favoriteLoading}
            aria-label="取消收藏"
            title="取消收藏"
          >
            {favoriteLoading ? (
              <LoaderIcon size={16} />
            ) : (
              <HeartIcon size={20} filled />
            )}
          </button>
        </div>
      </header>

      {showChinese && sentence.content_zh && (
        <p className={styles.textZh}>{sentence.content_zh}</p>
      )}
      {sentence.content_en && (
        <p className={styles.textEn}>{sentence.content_en}</p>
      )}
    </article>
  );
};

export default SentenceCard;

